import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';
import { labelPrintedAction } from 'store/actions/data';
import {
  WITH_COURIER,
  SELLER_PACKAGING,
  PRINT_LABEL,
  RE_PRINT_LABEL,
  PRINT_CUSTOMS_FORM,
  GENERATING_LABEL,
} from 'enums/order-state-enums';

export const LabelStateButton = ({ text, disabled, hoverText, status, order = {} }) => {
  const {
    shippingLabelToGoat,
    shippingLabel: shippingLabelUrl,
    commercialInvoice: commercialInvoiceUrl,
  } = order;
  const dispatch = useDispatch();
  const [isPrinted, setIsPrinted] = useState(status === WITH_COURIER);

  const handleClick = (url) => {
    if (url === shippingLabelUrl || shippingLabelToGoat) {
      dispatch(labelPrintedAction(order.number));
      setIsPrinted(true);
    }
    window.open(url, '_blank');
  };

  return (
    <>
      {status === SELLER_PACKAGING || status === WITH_COURIER ? (
        <>
          {shippingLabelUrl || shippingLabelToGoat ? (
            <LabelStateButton.PrintLabelButton
              onClick={() => handleClick(shippingLabelUrl || shippingLabelToGoat)}
            >
              {isPrinted ? RE_PRINT_LABEL : PRINT_LABEL}
            </LabelStateButton.PrintLabelButton>
          ) : (
            <LabelStateButton.PrintLabelButton disabled>
              {GENERATING_LABEL}
            </LabelStateButton.PrintLabelButton>
          )}
          {commercialInvoiceUrl && (
            <LabelStateButton.PrintCustomsButton onClick={() => handleClick(commercialInvoiceUrl)}>
              {PRINT_CUSTOMS_FORM}
            </LabelStateButton.PrintCustomsButton>
          )}
        </>
      ) : (
        <Tooltip placement="top" title={hoverText} trigger="hover">
          <LabelStateButton.StyledLabelStateButton disabled={disabled}>
            {text}
          </LabelStateButton.StyledLabelStateButton>
        </Tooltip>
      )}
    </>
  );
};

LabelStateButton.Base = styled.button`
  font-family: ${FONTS.emphasized};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 8px;
  text-transform: capitalize;
  width: 209px;
  height: 40px;
  text-align: center;

  &:focus {
    outline: none;
  }
`;

LabelStateButton.StyledLabelStateButton = styled(LabelStateButton.Base)`
  border: solid 1px ${COLORS.primaryAlertText};
  background-color: ${COLORS.primaryBackground};
  color: ${COLORS.primaryAlertText};
  cursor: auto;
  padding: 9px 14.5px 10px 14.5px;

  &:hover {
    color: ${COLORS.primaryAlertText};
  }

  &:disabled {
    color: ${COLORS.disabledText};
    border: 1px solid ${COLORS.primaryBorder};
    background-color: ${COLORS.primaryBackground};
  }
`;

LabelStateButton.PrintLabelButton = styled(LabelStateButton.Base)`
  border: solid 1px ${COLORS.primaryAlertText};
  background-color: ${COLORS.disabledText};
  color: ${COLORS.primaryText};
  cursor: pointer;
  border: none;
  padding: 9px 18px 10px 18px;

  &:hover {
    background-color: ${COLORS.secondaryBackground};
    color: ${COLORS.primaryText};
    border: 1px solid ${COLORS.primaryText};
  }

  &:disabled {
    color: ${COLORS.disabledText};
    border: 1px solid ${COLORS.primaryBorder};
    background-color: ${COLORS.primaryBackground};
    pointer: not-allowed;
  }
`;

LabelStateButton.PrintCustomsButton = styled(LabelStateButton.Base)`
  border: solid 1px ${COLORS.secondaryText};
  background-color: ${COLORS.primaryBackground};
  color: ${COLORS.primaryText};
  cursor: pointer;
  padding: 10px 6px;

  &:hover {
    background-color: ${COLORS.primaryBorder};
  }
`;

LabelStateButton.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hoverText: PropTypes.string,
  status: PropTypes.string,
  order: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
  }),
};

export default LabelStateButton;
